import React, { useEffect, useState } from "react";
import "./CreateRoutine.scss";
import { useNavigate } from "react-router-dom";
import { adminRequest } from "../../../utils/requestMethods";
import { BASE_URL } from "../../../utils/config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaArrowLeftLong } from "react-icons/fa6";
import Swal from "sweetalert2";

const CreateRoutine = () => {
  const initialFormData = {
    course: "",
    semester: "",
    day: "",
    copyFromDay: "",
    section: "",
    enrollmentSetupId: "",
    routinePeriodId: "",
  };
  const initialRoutineData = {
    subject: "",
    facultyId: "",
    timeSlotId: "",
    room: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [routineData, setRoutineData] = useState([initialRoutineData]);
  const [academicYears, setAcademicYears] = useState([]);
  const [routinePeriod, setRoutinePeriod] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [program, setProgram] = useState([]);
  const [semester, setSemester] = useState([]);
  const [subject, setSubject] = useState([]);
  const [sections, setSections] = useState([]);
  const [faculty, setFaculty] = useState([]);
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(-1);
  };

  useEffect(() => {
    const fetchProgram = async () => {
      try {
        const response = await adminRequest.get(
          `${BASE_URL}/course/getNameAndId`,
        );
        setProgram(response.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchProgram();
  }, []);

  useEffect(() => {
    const fetchEnrollment = async () => {
      try {
        const response = await adminRequest.get(
          `${BASE_URL}/enrollmentSetup/list`,
        );
        setAcademicYears(response.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchEnrollment();
  }, []);

  useEffect(() => {
    const fetchRoutinePeriod = async () => {
      if (!formData.enrollmentSetupId) return;

      try {
        const response = await adminRequest.post(
          `${BASE_URL}/routinePeriod/list/enrollmentSetupId`,
          { enrollmentSetupId: formData.enrollmentSetupId },
        );
        setRoutinePeriod(response.data.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchRoutinePeriod();
  }, [formData.enrollmentSetupId]);

  useEffect(() => {
    const fetchTimeSlots = async () => {
      try {
        const response = await adminRequest.get(`${BASE_URL}/timeSlot/list`);
        setTimeSlots(response.data.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchTimeSlots();
  }, []);

  useEffect(() => {
    if (formData.course) {
      const fetchSemester = async () => {
        try {
          const response = await adminRequest.post(
            `${BASE_URL}/course/getRunningSemestersById`,
            { id: formData.course },
          );
          setSemester(response.data.data);
        } catch (error) {
          console.log(error);
          setSemester([]);
        }
      };
      fetchSemester();
    }
  }, [formData.course]);

  useEffect(() => {
    if (formData.semester) {
      const fetchSubject = async () => {
        try {
          const response = await adminRequest.post(
            `${BASE_URL}/course/curriculum/subjects`,
            { id: formData.semester },
          );
          setSubject(response.data.data);
        } catch (error) {
          console.log(error);
          setSubject([]);
        }
      };
      fetchSubject();
    }
  }, [formData.semester]);

  useEffect(() => {
    if (formData.semester) {
      const fetchSection = async () => {
        try {
          const response = await adminRequest.post(
            `${BASE_URL}/section/list/by/curriculum`,
            { curriculumId: formData.semester },
          );
          setSections(response.data.data);
        } catch (error) {
          console.log(error);
        }
      };
      fetchSection();
    }
  }, [formData.semester]);

  useEffect(() => {
    const fetchFaculty = async () => {
      try {
        const response = await adminRequest.get(
          `${BASE_URL}/faculty/list/active`,
        );
        setFaculty(response.data.faculties);
      } catch (error) {
        console.log(error);
      }
    };
    fetchFaculty();
  }, []);

  useEffect(() => {
    const fetchRoutineByDay = async () => {
      if (
        !formData.copyFromDay ||
        !formData.course ||
        !formData.semester ||
        !formData.section ||
        !formData.enrollmentSetupId ||
        !formData.routinePeriodId
      )
        return;

      try {
        const response = await adminRequest.post(
          `${BASE_URL}/routine/list/day`,
          {
            day: formData.copyFromDay,
            course: formData.course,
            semester: formData.semester,
            curriculumSectionMapId: formData.section,
            enrollmentSetupId: formData.enrollmentSetupId,
            routinePeriodId: formData.routinePeriodId,
          },
        );

        setRoutineData(response.data.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchRoutineByDay();
  }, [
    formData.copyFromDay,
    formData.course,
    formData.semester,
    formData.section,
    formData.enrollmentSetupId,
    formData.routinePeriodId,
  ]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const routinesData = routineData.map((routine) => ({
        subject: routine.subject,
        facultyId: routine.facultyId,
        curriculumSectionMapId: formData.section,
        timeSlotId: routine.timeSlotId,
        room: routine.room,
        semester: formData.semester,
        program: formData.course,
        day: formData.day,
        enrollmentSetupId: formData.enrollmentSetupId,
        routinePeriodId: formData.routinePeriodId,
      }));

      const response = await toast.promise(
        adminRequest.post(`${BASE_URL}/routine/create`, {
          routine: routinesData,
        }),
        { pending: "Processing your request..." },
      );
      Swal.fire({
        title: "SUCCESS",
        icon: "success",
        confirmButtonColor: "#264796",
        text: `${response.data.message}`,
        confirmButtonText: "OK",
      });
      setFormData(initialFormData);
      setRoutineData([initialRoutineData]);
    } catch (error) {
      Swal.fire({
        title: "ROUTINE CREATION FAILED",
        icon: "error",
        confirmButtonColor: "#264796",
        html: `<pre style="white-space: pre-wrap; text-align: left; font-family: sans-serif; font-size: 14px;">${error.response.data.message}</pre>`,
        confirmButtonText: "OK",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRoutineChange = (index, field, value) => {
    const newRoutine = [...routineData];
    newRoutine[index][field] = value;
    setRoutineData(newRoutine);
  };

  const addRoutineFields = () => {
    setRoutineData([...routineData, { ...initialRoutineData }]);
  };

  const removeRoutineField = (index) => {
    const newRoutineData = [...routineData];
    newRoutineData.splice(index, 1);
    setRoutineData(newRoutineData);
  };

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      semester: "",
      section: "",
    }));
    setSemester([]);
    setSections([]);
  }, [formData.course]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      routinePeriodId: "",
    }));
    setRoutinePeriod([]);
  }, [formData.enrollmentSetupId]);

  return (
    <div className="createRoutineContainer">
      <div className="top">
        <span className="backIcon" onClick={handleBackClick}>
          <FaArrowLeftLong />
        </span>
        <span className="headerTitle">Create Routine</span>
      </div>
      <div className="bottom">
        <form onSubmit={handleSubmit}>
          <div className="courseWrapper">
            <div className="inputGroup">
              <label htmlFor="academicYear">Enrollment</label>
              <select
                name="enrollmentSetupId"
                value={formData.enrollmentSetupId}
                onChange={handleFormChange}
              >
                <option value="" disabled>
                  Select Enrollment
                </option>
                {academicYears.map((option, index) => (
                  <option value={option.id} key={index}>
                    {option.enrollmentBatch}
                  </option>
                ))}
              </select>
            </div>

            <div className="inputGroup">
              <label htmlFor="routinePeriodId">Routine Period</label>
              <select
                name="routinePeriodId"
                value={formData.routinePeriodId}
                onChange={handleFormChange}
              >
                <option value="" disabled>
                  Select Routine Period
                </option>
                {routinePeriod.map((option, index) => (
                  <option value={option.id} key={index}>
                    {`${option.effectiveFrom} to ${option.effectiveTo}`}
                  </option>
                ))}
              </select>
            </div>

            <div className="inputGroup">
              <label htmlFor="courses">Course</label>
              <select
                name="course"
                value={formData.course}
                onChange={handleFormChange}
              >
                <option value="" disabled>
                  Select Course
                </option>
                {program.map((option, index) => (
                  <option value={option.id} key={index}>
                    {option.short_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="inputGroup">
              <label htmlFor="semesters">Semester</label>
              <select
                name="semester"
                value={formData.semester}
                onChange={handleFormChange}
              >
                <option value="" disabled>
                  Select Semester
                </option>
                {semester.map((option, index) => (
                  <option value={option.id} key={index}>
                    {option.semester}
                  </option>
                ))}
              </select>
            </div>
            <div className="inputGroup">
              <label htmlFor="section">Section</label>
              <select
                name="section"
                value={formData.section}
                onChange={handleFormChange}
              >
                <option value="" disabled>
                  Select Section
                </option>
                {sections.map((option, index) => (
                  <option value={option.id} key={index}>
                    {option.Section.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="inputGroup">
              <label htmlFor="day">Day</label>
              <select
                name="day"
                value={formData.day}
                onChange={handleFormChange}
              >
                <option value="" disabled>
                  Select Day
                </option>
                <option value="SUNDAY">Sunday</option>
                <option value="MONDAY">Monday</option>
                <option value="TUESDAY">Tuesday</option>
                <option value="WEDNESDAY">Wednesday</option>
                <option value="THURSDAY">Thursday</option>
                <option value="FRIDAY">Friday</option>
              </select>
            </div>

            <div className="inputGroup">
              <label htmlFor="copyFromDay">Copy Routine From</label>
              <select
                name="copyFromDay"
                value={formData.copyFromDay}
                onChange={handleFormChange}
              >
                <option value="" disabled>
                  Select day to copy from
                </option>
                <option value="SUNDAY">Sunday</option>
                <option value="MONDAY">Monday</option>
                <option value="TUESDAY">Tuesday</option>
                <option value="WEDNESDAY">Wednesday</option>
                <option value="THURSDAY">Thursday</option>
                <option value="FRIDAY">Friday</option>
              </select>
            </div>
          </div>

          <div className="routineFields">
            {routineData.map((routine, index) => (
              <div key={index} className="routineFieldGroup">
                <select
                  name="subject"
                  value={routine.subject}
                  onChange={(e) =>
                    handleRoutineChange(index, "subject", e.target.value)
                  }
                >
                  <option value="" disabled>
                    Select Subject
                  </option>
                  {subject.map((option, idx) => (
                    <option value={option.subject_name} key={idx}>
                      {option.subject_name}
                    </option>
                  ))}
                </select>
                <select
                  name="facultyId"
                  value={routine.facultyId}
                  onChange={(e) =>
                    handleRoutineChange(index, "facultyId", e.target.value)
                  }
                >
                  <option value="" disabled>
                    Select Faculty
                  </option>
                  {faculty.map((option, idx) => (
                    <option value={option.id} key={idx}>
                      {option.name}
                    </option>
                  ))}
                </select>
                <select
                  name="timeSlotId"
                  value={routine.timeSlotId}
                  onChange={(e) =>
                    handleRoutineChange(index, "timeSlotId", e.target.value)
                  }
                >
                  <option value="" disabled>
                    Select Time Slot
                  </option>
                  {timeSlots.map((option, index) => (
                    <option value={option.id} key={index}>
                      {option.startTime} - {option.endTime}
                    </option>
                  ))}
                </select>
                <input
                  type="text"
                  placeholder="Room No"
                  value={routine.room}
                  onChange={(e) =>
                    handleRoutineChange(index, "room", e.target.value)
                  }
                />
                <div className="buttonGroup">
                  {index === routineData.length - 1 && (
                    <button
                      type="button"
                      className="addRoutineButton"
                      onClick={addRoutineFields}
                    >
                      +
                    </button>
                  )}
                  {index === routineData.length - 1 &&
                    routineData.length > 1 && (
                      <button
                        type="button"
                        className="removeRoutineButton"
                        onClick={() => removeRoutineField(index)}
                      >
                        -
                      </button>
                    )}
                </div>
              </div>
            ))}
          </div>

          <div className="submitWrapper">
            <button
              type="submit"
              className="create-btn"
              disabled={isSubmitting}
            >
              Submit
            </button>
            <button
              type="button"
              className="cancel-btn"
              onClick={handleBackClick}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateRoutine;
